import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { confirmLeaveGuard } from './guards/confirm-leave-guard';

export const routes: Routes = [
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard').then(com => com.Dashboard)
  },
  {
    path: 'issuer',
    canActivate: [authGuard],
    canDeactivate: [confirmLeaveGuard],
    loadComponent: () => import('./pages/issuer/issuer').then(com => com.Issuer)
  },
  {
    path: 'history',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/history/history').then(com => com.History)
  },
  {
    path: 'reports',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/reports/reports').then(com => com.Reports)
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    loadComponent: () => import('./pages/admin/admin').then(com => com.Admin),
  },
  {
    path: 'archived',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/archived/archived').then(com => com.Archived),
  },
  {
    path: 'notAuth',
    loadComponent: () => import('fi-ui-common').then(com => com.NotAuthComponent)
  },
  {
    path: 'help',
    loadComponent: () => import('./pages/help-info/help-info').then(com => com.HelpInfo)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
